import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type?: 'info' | 'error' | 'success';
  onDone: () => void;
  duration?: number;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  type = 'info',
  onDone,
  duration = 3000,
}) => {
  useEffect(() => {
    const t = setTimeout(onDone, duration);
    return () => clearTimeout(t);
  }, [onDone, duration]);

  return (
    <div className={`toast ${type}`}>
      {message}
    </div>
  );
};

export default Toast;
